import { type PropsWithChildren, useEffect } from 'react';

import { referenceApi } from 'src/app/services/Reference/Reference.service';
import { Loading } from 'src/components/base';
import {
  ReferenceContext,
  useReferenceContextCreator,
} from 'src/components/contexts/ReferenceContext/ReferenceContext.context';

export function ReferenceContextContainer({ children }: Readonly<PropsWithChildren>) {
  const referenceContext = useReferenceContextCreator();

  const [{ data: productReferences }] = referenceApi.useGetProductReferencesQuery();
  const [{ data: productSpecificationReferences }] = referenceApi.useGetProductSpecificationReferencesQuery();
  const [{ data: enumReferences }] = referenceApi.useGetEnumReferencesQuery();

  // biome-ignore lint/correctness/useExhaustiveDependencies: false
  useEffect(() => {
    if (productReferences) {
      referenceContext.setProductTypes(productReferences);
    }

    if (productSpecificationReferences) {
      referenceContext.setProductSpecifications(productSpecificationReferences);
    }

    if (enumReferences) {
      referenceContext.setEnumReferences(enumReferences);
    }

    if (productReferences && productSpecificationReferences && enumReferences) {
      referenceContext.setReferencesLoading(false);
    }
  }, [productReferences, productSpecificationReferences, enumReferences]);

  if (referenceContext.isReferencesLoading) {
    return (
      <div className="flex-1 flex column justify-content-center align-items-center">
        <Loading isGlobal={true} size={64} />
      </div>
    );
  }

  return <ReferenceContext.Provider value={referenceContext}>{children}</ReferenceContext.Provider>;
}
